module.exports = __webpack_public_path__ + "static/media/congrat_watch.c5bb94be.png";